export default __webpack_public_path__ + "static/media/password-dots.89226650.svg";